import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Flashlight } from '@bibliocommons/base-icons';
import DidNotFind from '../DidNotFind';
import ChatWidgetButton from '../ChatWidgetButton';
import { ExpandablePanel } from '@bibliocommons/expandable';

import './DidNotFindExpandablePanel.scss';

function renderTriggerContent() {
  return (
    <FormattedMessage id="did_not_find_discover" />
  );
}

function renderChatWidgetButton(chatWidgets) {
  const enabledWidget = chatWidgets.findLastKey(widget => widget.get('enabled'));

  if (enabledWidget) {
    return (
      <span className="did-not-find-collapible-chat-widget">
        <ChatWidgetButton widget={enabledWidget} />
      </span>
    );
  }

  return null;
}

function renderHeader(chatWidgets) {
  return (
    <div className="did-not-find-heading-content">
      <div className="panel-title">
        <Flashlight />
        <FormattedMessage id="did_not_find_heading" />
      </div>
      {renderChatWidgetButton(chatWidgets)}
    </div>
  );
}


export default function DidNotFindExpandablePanel({ query, didNotFindOptions, chatWidgets }) {
  return (
    <ExpandablePanel
      className="did-not-find-expandable-panel"
      renderHeaderContent={() => renderHeader(chatWidgets)}
      renderExpandButtonLabel={() => renderTriggerContent()}>
      <DidNotFind query={query} didNotFindOptions={didNotFindOptions} />
    </ExpandablePanel>
  );
}

DidNotFindExpandablePanel.propTypes = {
  query: PropTypes.string,
  didNotFindOptions: ImmutablePropTypes.map,
  chatWidgets: ImmutablePropTypes.mapOf(PropTypes.object)
};



// WEBPACK FOOTER //
// ./app/components/search/DidNotFindExpandablePanel/DidNotFindExpandablePanel.jsx